import { render, staticRenderFns } from "./SimpleNestedPage.vue?vue&type=template&id=7ffbe572"
import script from "./SimpleNestedPage.vue?vue&type=script&lang=js"
export * from "./SimpleNestedPage.vue?vue&type=script&lang=js"
import style0 from "./SimpleNestedPage.vue?vue&type=style&index=0&id=7ffbe572&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports